<div aria-labelledby="documentsHeading" class="documents-header">
    <h1 id="documentsHeading" class="documents-header-title">My Documents</h1>
    @if (status()) {
      <status-badge
        [status]="status()"
        [message]="status()">
      </status-badge>
    }
</div>
<div class="document">
  <div class="document__container">
      @if (loading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @if (!loading()) {
      <div class="document__header">
        <h1  
          aria-labelledby="Document Page Header"
          class="document__header-label navy-text">
          {{'Uploaded Documents (' + getDocumentsLength() + ')'}}
        </h1>
      </div>

      <cfi-mat-table 
        data-pw="documentsTable" 
        data-qa="documentsTable" 
        [columnDefinitions]="columnDefinitions"
        [columnsToDisplayWithExpand]="displayedColumns" 
        [data]="documentTableData()" 
        [displayedColumns]="displayedColumns"
        [(expandedElement)]="expandedElement"
        (expandedElementChange)="onExpandedElementChange($event)">
        <!-- Header Template -->
        <ng-template #headerTemplate  
                     aria-labelledby="Document Header name"
                     let-column>
          {{ column.header }}
        </ng-template>

        <ng-template #downloadButtonTemplate let-document="document" let-prefix="prefix">
          <button
            type="button"
            class="icon-action-button"
            (click)="downloadDocument(document)"
            [attr.data-pw]="prefix + document.id"
            [class.disabled]="status() === ProviderInfoStatus.Denied"
            [disabled]="status() === ProviderInfoStatus.Denied">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.56255 0.562503C9.56255 0.253126 9.30943 0 9.00005 0C8.69067 0 8.43755 0.253126 8.43755 0.562503V11.5805L4.89729 8.04028C4.67932 7.82231 4.32073 7.82231 4.10276 8.04028C3.88479 8.25825 3.88479 8.61684 4.10276 8.83481L8.60278 13.3348C8.82075 13.5528 9.17935 13.5528 9.39732 13.3348L13.8973 8.83481C14.1153 8.61684 14.1153 8.25825 13.8973 8.04028C13.6794 7.82231 13.3208 7.82231 13.1028 8.04028L9.56255 11.5805V0.562503ZM4.92542 11.2501H2.25001C1.00899 11.2501 0 12.2591 0 13.5001V15.7501C0 16.9911 1.00899 18.0001 2.25001 18.0001H15.7501C16.9911 18.0001 18.0001 16.9911 18.0001 15.7501V13.5001C18.0001 12.2591 16.9911 11.2501 15.7501 11.2501H13.0747L11.9497 12.3751H15.7501C16.3724 12.3751 16.8751 12.8778 16.8751 13.5001V15.7501C16.8751 16.3724 16.3724 16.8751 15.7501 16.8751H2.25001C1.62774 16.8751 1.12501 16.3724 1.12501 15.7501V13.5001C1.12501 12.8778 1.62774 12.3751 2.25001 12.3751H6.05042L4.92542 11.2501ZM15.1876 14.6251C15.1876 14.4013 15.0987 14.1867 14.9405 14.0285C14.7822 13.8702 14.5676 13.7813 14.3438 13.7813C14.1201 13.7813 13.9054 13.8702 13.7472 14.0285C13.589 14.1867 13.5001 14.4013 13.5001 14.6251C13.5001 14.8489 13.589 15.0635 13.7472 15.2217C13.9054 15.3799 14.1201 15.4688 14.3438 15.4688C14.5676 15.4688 14.7822 15.3799 14.9405 15.2217C15.0987 15.0635 15.1876 14.8489 15.1876 14.6251Z"
                fill="#003D57"/>
            </svg>
          </button>
        </ng-template>

        <!-- Cell Template -->
        <ng-template #cellTemplate let-document let-column="column">
          <ng-container>
            @switch (column.name) {
              @case ('action') {
                <ng-container>
                  <div class="documents-action">
                    <ng-container
                      [ngTemplateOutlet]="downloadButtonTemplate"
                      [ngTemplateOutletContext]="{ document: document, prefix: 'document-download-' }">
                    </ng-container>
                  </div>
                </ng-container>
              }
              @default {
                <ng-container>
                  @if (column.name === 'lastModified') {
                    <td class="table-cell__description" [attr.data-pw]="'cell-' + column.name">
                      {{ document[column.name] | date: 'MM/dd/yyyy h:mm a' }}
                    </td>
                  } @else {
                    <td
                      class="table-cell__icon-container"
                      [attr.data-pw]="'cell-' + column.name"
                      [style.width.%]="column.width">
                        {{ document[column.name] }}
                    </td>
                  }
                </ng-container>
              }
            }
          </ng-container>
        </ng-template>

        <!-- Expanded Content Template -->
        <ng-template #expandedRow let-subCell>
          @for (column of columnDefinitions; track column.name; let i = $index) {
            <div 
                 class="table-cell__icon-container" 
                 [attr.data-pw]="'expandedCell-' + column.name"
                 [style.width.%]="getExandedColumnWidth(column.name)">
              <div class="subtask-content">
                  <ng-container>
                        @switch (column.name) {
                            @case ('action') {
                              @if (showActionColumn()) {
                                <div class="subtask-action">
                                  <ng-container
                                    [ngTemplateOutlet]="downloadButtonTemplate"
                                    [ngTemplateOutletContext]="{ document: subCell, prefix: 'expanded-document-download-' }">
                                  </ng-container>
                                </div>
                              }                             
                            }
                            @default {
                              <ng-container>
                                <span class="subtask-value" 
                                      [attr.data-pw]="'subtask-' + column.name">
                                      {{ subCell[column.name] }}
                                </span>
                              </ng-container>
                            }
                        }
                </ng-container>
              </div>
            </div>
          }
        </ng-template>
      </cfi-mat-table>
    }
  </div>
</div>